import styled from 'styled-components';
import { IFrame } from './interface';

const templateArea = `
  " cl cl cl fares fares clients clients partners" 
  " cl cl cl fares fares clients clients users"
  "boleto boleto boleto ted ted ted tev tev"
  "boleto boleto boleto ted ted ted tev tev" 
  "boleto boleto boleto ted ted ted paids paids" 
  "boleto boleto boleto ted ted ted recharge recharge" 

`;

const base = styled.div<IFrame>`
  display: ${(props) => (props.isActive ? 'grid' : 'none')};
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(2, 1fr) repeat(4, 0.5fr);
  grid-template-areas: ${templateArea};
  row-gap: 1rem;
  column-gap: 1rem;
  width: 100%;
  height: auto;
  padding: 1rem;

  @media (min-width: ${(props) => props.theme.mediaQuery.desktop}) {
    grid-template-rows: repeat(6, 1fr);
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
